///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2025, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2025 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import { Viewer } from "../Viewer";
import { ZoomAction } from "./Actions/ZoomAction";
import { OdBaseDragger } from "./Common/OdBaseDragger";

export class OdZoomDragger extends OdBaseDragger {
  private _zoomAction: ZoomAction;
  protected pressX: number;
  protected pressY: number;
  protected absoluteX: number;
  protected absoluteY: number;
  protected prevY: number;

  constructor(subject: Viewer) {
    super(subject);
    this.autoSelect = true;
    this.press = false;
    this._zoomAction = new ZoomAction(this.m_module, this.subject);
  }

  override start(x: number, y: number, absoluteX = 0, absoluteY = 0): void {
    this.press = true;
    this.pressX = x;
    this.pressY = y;
    this.absoluteX = absoluteX;
    this.absoluteY = absoluteY;
    this.prevY = y;
    this.beginInteractivity();
  }

  override drag(x: number, y: number): void {
    const dltY = y - this.prevY;
    this.prevY = y;

    if (this.press && Math.abs(dltY) >= 10e-6) {
      const ZOOM_SPEED = 0.975;
      const zoomFactor = dltY > 0 ? 1 / ZOOM_SPEED : ZOOM_SPEED;
      this._zoomAction.action(this.pressX, this.pressY, zoomFactor, this.absoluteX, this.absoluteY);
    }
  }

  override end(): void {
    this.press = false;
    this.endInteractivity();
  }
}
